module.exports = __webpack_public_path__ + "static/media/sem-na-pravi-poti.4ae12200.png";